import { FC, ReactNode, memo } from "react";
import { Flex, Tag, Typography, Tooltip } from "antd";

import styles from "./status.module.css";

type StatusProps = {
  className?: string;
  color: string;
  children: ReactNode;
  tooltip?: string;
  uppercase?: boolean;
  withoutBorder?: boolean;
  withoutDot?: boolean;
  id?: string;
  date?: string;
  alignRight?: boolean;
};

const backgroundColor: Record<StatusProps["color"], string> = {
  green: "var(--ant-green-3)",
  blue: "var(--ant-blue-3)",
  gray: "var(--ant-color-basic-300)",
  yellow: "var(--ant-yellow)",
  red: "var(--ant-red-1)",
  purple: "var(--ant-purple-2)",
};

export const Status: FC<StatusProps> = memo(({
  children,
  className = "",
  color = "gray",
  tooltip,
  uppercase,
  withoutBorder = false,
  withoutDot = true,
  id,
  date,
  alignRight = true,
}) => {
  const tagContent = (
    <Flex justify={alignRight ? "flex-end" : "flex-start"}>
      <Tag
        id={id}
        color={backgroundColor[color]}
        className={`${styles.tag} ${uppercase ? "text-uppercase" : ""} ${
          withoutBorder ? "border-none" : ""
        } ${className}`}
      >
        <div className={`${withoutDot ? "" : styles.dot} ${styles[color]}`} />
        {children}
      </Tag>
    </Flex>
  );

  const TagComponent = tooltip ? <Tooltip title={tooltip}>{tagContent} </Tooltip> : tagContent;

  if (date) {
    return (
      <Flex vertical gap="small" align={alignRight ? "end" : "flex-start"}>
        {TagComponent}
        <Typography.Text type="secondary">{date}</Typography.Text>
      </Flex>
    );
  }

  return TagComponent;
});
